import { IActivity } from "@wingspanhq/users/dist/lib/interfaces";
import { PayablesSettings } from "../steps/PayrollSettings/PayablesSettings";
import { PayrollSchedule } from "../steps/PayrollSettings/PayrollSchedule";
import { OnboardingContext, OnboardingModulePayrollSettings } from "../types";
import {
  buildOnboardingStep,
  UseCreateOnboardingStep,
  useOnboardingStepQueryConfig
} from "../components/OnboardingFlowUtils";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryActivities } from "../../../query/users/queries";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

const getStatus = (activity?: IActivity) => {
  if (
    activity?.flows.onboardingPayrollSettings?.complete &&
    activity?.flows.onboardingPayableSettings?.complete
  ) {
    return "Complete";
  }

  return "None";
};

export const getPayrollSettingsStepConfig = (
  _: OnboardingModulePayrollSettings,
  __: OnboardingContext,
  activity?: IActivity
): FlowStep => {
  const slug = "payroll-settings";

  const steps: FlowStep[] = [
    {
      title: "Payroll schedule",
      slug: "payroll-schedule",
      component: PayrollSchedule
    },
    {
      title: "Payables settings",
      slug: "payables-settings",
      component: PayablesSettings
    }
  ];

  const status = getStatus(activity);

  return {
    title: "Payroll settings",
    slug,
    steps,

    status,
    result: {
      Complete: {
        title: "Your payroll settings were saved",
        description:
          "The payroll settings your selected were saved. Click continue for the next step."
      }
    }
  };
};

export const usePayrollSettingsStep: UseCreateOnboardingStep<
  OnboardingModulePayrollSettings
> = modules => {
  const config = useOnboardingStepQueryConfig(modules, "payroll_settings");
  const userId = useUserId();
  const queryActivity = useQueryActivities(userId, config);

  return (onboardingModule, contextValue) =>
    buildOnboardingStep({
      getConfig: getPayrollSettingsStepConfig,
      module: onboardingModule,
      context: contextValue,
      queries: [queryActivity]
    });
};
